import { render, staticRenderFns } from "./TicketsByType.vue?vue&type=template&id=717957fa&scoped=true&"
import script from "./TicketsByType.vue?vue&type=script&lang=ts&"
export * from "./TicketsByType.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsByType.vue?vue&type=style&index=0&id=717957fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717957fa",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCardTitle,VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('717957fa')) {
      api.createRecord('717957fa', component.options)
    } else {
      api.reload('717957fa', component.options)
    }
    module.hot.accept("./TicketsByType.vue?vue&type=template&id=717957fa&scoped=true&", function () {
      api.rerender('717957fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/dashboard/components/TicketsByType.vue"
export default component.exports